import { render, staticRenderFns } from "./StoresList.vue?vue&type=template&id=52f0d37c&scoped=true&"
import script from "./StoresList.vue?vue&type=script&lang=js&"
export * from "./StoresList.vue?vue&type=script&lang=js&"
import style0 from "./StoresList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./StoresList.vue?vue&type=style&index=1&id=52f0d37c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f0d37c",
  null
  
)

export default component.exports